import {Component, OnInit} from '@angular/core';
import {NgxSpinnerService} from "ngx-spinner";
import {GrantApplicationResponse} from "../../../models/grantApplication/grantApplicationResponse";
import {GrantApplicationService} from "../../../services/grantApplication.service";
import {Router} from "@angular/router";
import { SweetAlertService } from "../../../services/sweet-alert.service";

@Component({
  selector: 'app-application',
  templateUrl: './application.component.html',
  styleUrls: ['./application.component.scss']
})
export class ApplicationComponent implements OnInit {
  applications: GrantApplicationResponse[] = [];
  currentPage: number = 1;
  totalItems: number = 25;
  disabled: boolean = false;
  sortColumn: string = 'ProjectName';
  configTableMaxRow: number = 10;

  constructor(
    private spinner: NgxSpinnerService,
    private grantApplication: GrantApplicationService,
    private router: Router,
    private sweetAlertService: SweetAlertService
  ) {

  }

  ngOnInit(): void {
    this.loadApplicationList();
  }

  pageChanged(event: any): void {
    console.log('Page changed to: ' + event.page);
    this.loadApplicationList(event.page);
  }

  sort(column: string) {
    console.log('sorted');
    this.sortColumn = column;
    this.currentPage = 1;
    this.loadApplicationList(this.currentPage);
  }

  loadApplicationList(page: number = 1) {
    this.spinner.show();
    this.grantApplication.getApplicationList(page, this.configTableMaxRow, this.sortColumn).subscribe(
      async data => {
       await this.spinner.hide();

        if (!data.result) {

          await this.sweetAlertService.error(
            'Error',
            data.messages?.join(' ') || 'An unexpected error occurred. Please try again.'
          );
        } else {
          this.applications = data.item?.items ?? [];
          this.totalItems = data.item?.total ?? 0;
          this.currentPage = page;
        }
      },
      async error => {
        await this.spinner.hide();
        console.error('Error fetching projects:', error);


      await this.sweetAlertService.error(
          'Error',
          'Something went wrong while loading applications. Please try again later.'
        );
      }
    );
  }


  getBadgeClass(status: string|undefined): string {
    if (!status) {
      return '';
    }
    switch (status.trim()) {
      case 'Approved':
        return 'badge badge-success';
      case 'Submitted':
        return 'badge badge-primary';
      case 'Not submitted':
        return 'badge badge-secondary';
      default:
        return 'badge badge-secondary';
    }
  }


  navigateToDetails(application: GrantApplicationResponse, status: string) {

    const appid = application.grantApplicationId;
    this.router.navigate(['/applications', 'details', appid], {queryParams: {status: status,grantApplicationType:application.grantApplicationType}});

  }
}
